import { Box, Skeleton } from '@mui/material';
import ContentBox from '@root/components/v2/content/ContentBox';
import { SEVERITY_COLORS } from '@root/utilities/pastelColors';
import React from 'react';
import './SeverityCountCard.scss';

// Mirrors the dashboard's Open Threats / Anomaly card: a severity accent bar beside each count and label.
const getSeverityColor = severity => SEVERITY_COLORS[severity?.toLowerCase()] ?? SEVERITY_COLORS.other;

export const SeverityCountCard = ({ title, children }) => (
  <ContentBox
    title={title}
    height="180px"
    containerStyle={{
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '15px',
      overflow: 'hidden',
    }}
    style={{ borderRadius: '5px' }}
    titleSize="medium"
    titleContainerStyle={{
      fontSize: '16px !important',
      color: 'var(--keyinsight-text-color)',
    }}
    paddingMode="content"
    containerClassName="border-box-no-pad">
    {children}
  </ContentBox>
);

export const SeverityCountGrid = ({ items }) => (
  <div className="MalwareSeverityCard__Grid">
    {items.map(item => (
      <div key={item.severity} className="MalwareSeverityCard__Item">
        <span className="MalwareSeverityCard__Bar" style={{ background: getSeverityColor(item.severity) }} />
        <div className="MalwareSeverityCard__Text">
          <p
            className="MalwareSeverityCard__Count"
            data-testid={item.testId}
            {...(item.onClick && { 'data-clickable': 'true', onClick: item.onClick })}
            style={{ cursor: item.isClickable ? 'pointer' : 'default' }}>
            {item.count}
          </p>
          <p className="MalwareSeverityCard__Label SingleLine">{item.label}</p>
        </div>
      </div>
    ))}
  </div>
);

export const SeverityCountCardSkeleton = ({ title, rows = 4 }) => (
  <SeverityCountCard title={title}>
    <div className="MalwareSeverityCard__Grid">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="MalwareSeverityCard__Item">
          <Skeleton variant="rounded" width={5} height={41} sx={{ flexShrink: 0, borderRadius: '10px' }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: 0, flex: 1 }}>
            <Skeleton variant="text" width={34} height={24} />
            <Skeleton variant="text" width="70%" height={17} />
          </Box>
        </div>
      ))}
    </div>
  </SeverityCountCard>
);
